module.exports = __webpack_public_path__ + "static/img/1.4ca2555.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/1.png
// module id = Yjf0
// module chunks = 0